import React, { useEffect } from "react";
import styled from "styled-components";
import { FormRow, FormRowMessage, FormTextbox, Alert, TitleStack, BlockButton, Spinner, FormCheckbox, FormSelect } from "fiver-react-ui-components";
import { useState } from "react";
import { debounce } from "lodash";
import axios from "axios";
import { useRef } from "react";
import { validateEmail } from "../utils";
const StyledWrapper = styled.div``;
export const StyledSpinner = styled(Spinner)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1rem;
  margin: auto;
`;
const StyledButton = styled.button`
  font-size: 0.75rem;
  padding: 0;
  margin-bottom: 1rem;
  color: ${props => props.theme.colorAccent};
`;
const StyledCheckboxLink = styled.button`
  padding: 0;
  font-size: 0.75rem;
  color: ${p => p.theme.colorAccent};
  cursor: pointer;
`;

const SignupStep = ({
  translations,
  onStepClicked,
  isStepValid,
  values,
  errors,
  dirty,
  handleChange,
  handleBlur,
  hideMobileVerificationMessage,
  hideMobileNumberCheckbox,
  hideMobileNumberAlert,
  setFieldValue,
  setFieldTouched,
  dialingCode,
  forcedCountryCode,
  isNonUk,
  location,
  colorPrimary,
  touched,
  onPageButtonClicked,
  smsSlug,
  useAssetsCdn,
  tenantDetails
}) => {
  const [states, setStates] = useState([]);
  const [asyncEmailError, setAsyncEmailError] = useState(undefined);
  const [emailLoading, setEmailLoading] = useState(false); // useEffect(() => {
  //   if (values.mobileNumber === "") {
  //     setFieldValue("mobileNumber", `+${dialingCode}`);
  //   }
  // }, [dialingCode]);

  useEffect(() => {
    window.xtremepush("tag", "registration_contact_details", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);

  const handleChangeEmail = async (e, callback) => {
    const {
      value,
      name
    } = e.target;
    console.log("validateEmail", validateEmail(value));

    if (validateEmail(value)) {
      setEmailLoading(true);
      await axios.get(`/users/email/${value.trim()}`).then(({
        data
      }) => {
        setEmailLoading(false);

        if (!data.available) {
          setAsyncEmailError(translations.existsEmail);
        } else {
          setAsyncEmailError(undefined);
        }
      }).catch(() => {
        setEmailLoading(false);
        setAsyncEmailError("Something went wrong!");
      });
    }

    callback(name, true, true);
  };

  const refHandlerEmail = useRef(debounce(handleChangeEmail, 350));
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(TitleStack, {
    title: `${translations.step} 2`,
    subtitle: translations.messageContactDetails
  }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isRequired: true,
    isError: values.email && errors.email || asyncEmailError,
    minLength: 1,
    debounceTimeout: 350,
    onChange: e => {
      handleChange(e);
      refHandlerEmail.current(e, setFieldTouched);
    },
    onBlur: handleBlur,
    name: "email",
    value: values.email,
    placeholder: translations.email
  }), emailLoading && /*#__PURE__*/React.createElement(StyledSpinner, {
    lineWidth: 5
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.email && errors.email || asyncEmailError
  }, errors.email, !errors.email ? asyncEmailError : ""), !hideMobileNumberAlert && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(Alert, {
    textAlign: "left"
  }, translations.signUpMobileWarning, " +", dialingCode, "123456789")), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    type: "tel",
    name: "mobileNumber",
    placeholder: translations.mobileNumber,
    prefix: forcedCountryCode === "" ? `+${dialingCode}` : `+${forcedCountryCode}`,
    value: values.mobileNumber,
    isError: values.mobileNumber !== "" && errors.mobileNumber,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.mobileNumber !== "" && errors.mobileNumber
  }, errors.mobileNumber), values.mobileNumber.length <= 3 && !hideMobileVerificationMessage && /*#__PURE__*/React.createElement(Alert, {
    isDefault: true,
    textAlign: "left",
    margin: "0 0 1rem"
  }, translations.mobileVerificationMessage), !hideMobileNumberCheckbox && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
    isSmallerText: true,
    name: "smsNotificationsAccepted",
    alignItems: "flex-start",
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Yes! I would like to receive", " ", /*#__PURE__*/React.createElement(StyledCheckboxLink, {
      type: "button",
      onClick: e => {
        e.stopPropagation();
        onPageButtonClicked(smsSlug, translations.smsCommunications, useAssetsCdn);
      }
    }, translations.smsCommunications), " ", "to my phone placed via an autodialer from (or on behalf of)", " ", tenantDetails?.complianceName, "."),
    onLabelLinkClicked: () => onPageButtonClicked(smsSlug, translations.smsCommunications, useAssetsCdn),
    checked: values.smsNotificationsAccepted,
    onChange: e => {
      window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      handleChange(e);
    },
    onBlur: handleBlur
  })), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(2),
    disabled: !dirty || !isStepValid || asyncEmailError,
    style: {
      marginBottom: "1rem"
    }
  }, translations.next), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(0)
  }, translations.back));
};

export default SignupStep;